export const QUERIES = {
  exclusiveContents: 'exclusiveContents',
};
